import React, { FC, memo } from 'react';
import classNames from 'classnames';
import {
  GenericTextProps,
  LetterSpacing,
  TextAlign,
  TextDecoration,
  TextSize,
  TextTransform,
  TextWeight,
} from './GenericText.types';
import {
  alignClasses,
  decorationClasses,
  letterSpacingClasses,
  sizeClasses,
  transformClasses,
  weightClasses,
} from './GenericText.consts';

const GenericText: FC<GenericTextProps> = ({
  children,
  as = 'p',
  size = TextSize.BASE,
  mobileSize = TextSize.SM,
  customSize,
  mobileCustomSize,
  weight = TextWeight.NORMAL,
  align = TextAlign.LEFT,
  color,
  backgroundColor,
  lineHeight,
  mobileLineHeight,
  transform = TextTransform.NORMAL,
  decoration = TextDecoration.NONE,
  width,
  isFullWidth = false,
  className = '',
  role,
  hoverEffect = '',
  truncate = false,
  italic = false,
  letterSpacing = LetterSpacing.NORMAL,
  testId,
}) => {
  if (!children) {
    return null;
  }

  const classes = classNames(
    {
      [`md:${sizeClasses[size]}`]: !customSize,
      [`${sizeClasses[mobileSize]}`]: !mobileCustomSize,
      [`md:text-[${customSize}px]`]: !!customSize,
      [`text-[${mobileCustomSize}px]`]: !!mobileCustomSize,
      [`md:leading-[${lineHeight}px]`]: !!lineHeight,
      [`leading-[${mobileLineHeight}px]`]: !!mobileLineHeight,
      [weightClasses[weight]]: true,
      [alignClasses[align]]: true,
      [transformClasses[transform]]: true,
      [decorationClasses[decoration]]: true,
      [letterSpacingClasses[letterSpacing]]: letterSpacing,
      'w-full': isFullWidth,
      italic: italic,
      truncate: truncate,
      [hoverEffect]: hoverEffect,
    },
    className,
  );

  const style = {
    ...(color && { color }),
    ...(backgroundColor && { backgroundColor }),
    ...(lineHeight && { lineHeight }),
    ...(width && !isFullWidth && { width }),
  };

  return React.createElement(
    as,
    {
      className: classes,
      style: Object.keys(style).length > 0 ? style : undefined,
      role,
      'data-testid': testId,
    },
    children,
  );
};

export default memo(GenericText);
